'use strict';
export default function routes($stateProvider) {
    'ngInject';
    $stateProvider
        .state('brands', {
        url: '/brands/directory/:filterItem',
        template: require('./template.html'),
        controller: 'BrandsController',
        controllerAs: 'brvm'
    });
}
//# sourceMappingURL=brands.routes.js.map